export enum IAdminHeaderLinkType {
  Button = 'button',
  Link = 'link',
}
export interface IAdminHeaderLink {
  title: string;
  link: string;
  icon?: string;
  accessTag?: string;
  id?: string;
  counter?: number | string;
  customClass?: string;
  type?: IAdminHeaderLinkType;
  visible?: boolean;
  position?: number;
}


